(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lunqo-landing-content"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('toggle',(e)=>{if(e.target.matches('[data-lunqo-faq]')&&e.target.open){document.dispatchEvent(new CustomEvent('lunqo:interaction',{detail:{name:'faq_open',question:e.target.querySelector('summary')?.textContent?.trim()||''}}));}},true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lunqo-landing-message"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-lunqo-scroll]');
    if (!link) return;
    const target = document.querySelector(link.getAttribute('href'));
    if (!target) return;
    event.preventDefault();
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lunqo-main-collection"] && !Shopify.designMode) return;
  try {
    
  class LunqoCollection extends HTMLElement {
    static viewedCollections = new Set();
    static viewedProducts = new Set();

    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.grid = this.querySelector('[data-product-grid]');
      this.loadButton = this.querySelector('[data-load-more]');
      this.filterDetails = this.querySelector('[data-filter-drawer]');
      this.abortController = new AbortController();
      this.restoreSavedState();
      this.bindEvents();
      this.observeProducts();
      this.updateProgress();

      if (!LunqoCollection.viewedCollections.has(this.dataset.collectionHandle)) {
        LunqoCollection.viewedCollections.add(this.dataset.collectionHandle);
        this.track('collection_view', {
          collection_handle: this.dataset.collectionHandle,
          product_count: Number(this.dataset.totalProducts)
        });
      }
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.observer?.disconnect();
    }

    bindEvents() {
      const signal = this.abortController.signal;

      this.querySelector('[data-filter-form]')?.addEventListener('submit', (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        const params = new URLSearchParams(new FormData(form));
        this.track('filter_applied', { filters: this.serialiseFilters(params) });
        this.closeFilters();
        this.renderUrl(`${form.action}?${params.toString()}`, true);
      }, { signal });

      this.querySelector('[data-sort-select]')?.addEventListener('change', (event) => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', event.target.value);
        url.searchParams.delete('page');
        this.track('sort_changed', { sort_by: event.target.value });
        this.renderUrl(url.toString(), true);
      }, { signal });

      this.querySelectorAll('[data-filter-remove]').forEach((link) => {
        link.addEventListener('click', (event) => {
          event.preventDefault();
          this.track('filter_removed', { label: link.textContent.trim() });
          this.renderUrl(link.href, true);
        }, { signal });
      });

      this.querySelector('[data-clear-all]')?.addEventListener('click', (event) => {
        event.preventDefault();
        this.track('clear_all', {});
        this.renderUrl(event.currentTarget.href, true);
      }, { signal });

      this.querySelectorAll('[data-grid-density]').forEach((button) => {
        button.addEventListener('click', () => {
          const density = button.dataset.gridDensity;
          this.dataset.density = density;
          this.querySelectorAll('[data-grid-density]').forEach((candidate) => {
            candidate.setAttribute('aria-pressed', String(candidate === button));
          });
          localStorage.setItem('lunqo-collection-density', density);
          this.track('grid_density_changed', { density });
        }, { signal });
      });

      const savedDensity = localStorage.getItem('lunqo-collection-density');
      if (savedDensity && this.querySelector(`[data-grid-density="${savedDensity}"]`)) {
        this.dataset.density = savedDensity;
        this.querySelectorAll('[data-grid-density]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.gridDensity === savedDensity));
        });
      }

      this.loadButton?.addEventListener('click', () => this.loadMore(), { signal });
      this.querySelector('[data-filter-close]')?.addEventListener('click', () => this.closeFilters(), { signal });

      this.filterDetails?.addEventListener('keydown', (event) => this.handleDrawerKeys(event), { signal });
      this.filterDetails?.addEventListener('toggle', () => {
        const panel = this.filterDetails.querySelector('[role="dialog"]');
        const isMobileDrawer = window.matchMedia('(max-width: 989px)').matches;
        panel?.setAttribute('aria-modal', String(this.filterDetails.open && isMobileDrawer));
        if (this.filterDetails.open && isMobileDrawer) {
          requestAnimationFrame(() => this.filterDetails.querySelector('[data-filter-close]')?.focus());
        }
      }, { signal });

      this.querySelectorAll('[data-product-card-link]').forEach((link) => {
        link.addEventListener('click', () => {
          const card = link.closest('[data-product-card]');
          this.saveState();
          this.track(link.hasAttribute('data-choose-options') ? 'choose_options' : 'product_card_click', {
            product_id: card?.dataset.productId,
            product_handle: card?.dataset.productHandle
          });
        }, { signal });
      });

      this.querySelectorAll('[data-quick-add]').forEach((button) => {
        button.addEventListener('click', () => {
          const card = button.closest('[data-product-card]');
          this.track('quick_add', {
            product_id: card?.dataset.productId,
            product_handle: card?.dataset.productHandle,
            variant_id: button.dataset.variantId
          });
        }, { signal });
      });
    }

    async renderUrl(url, pushHistory) {
      this.setBusy(true);
      try {
        const requestUrl = new URL(url, window.location.origin);
        requestUrl.searchParams.set('section_id', this.sectionId);
        const response = await fetch(requestUrl, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        if (!response.ok) throw new Error(`Collection request failed: ${response.status}`);
        const html = await response.text();
        const documentFragment = new DOMParser().parseFromString(html, 'text/html');
        const next = documentFragment.querySelector(`#LunqoCollection-${CSS.escape(this.sectionId)}`);
        if (!next) throw new Error('Collection section missing from response');

        if (pushHistory) {
          const browserUrl = new URL(url, window.location.origin);
          browserUrl.searchParams.delete('section_id');
          history.pushState({}, '', browserUrl);
        }
        this.replaceWith(next);
        window.scrollTo({ top: Math.max(0, next.offsetTop - 16), behavior: 'auto' });
      } catch (error) {
        this.showError();
      } finally {
        this.setBusy(false);
      }
    }

    async loadMore() {
      const deferred = [...this.querySelectorAll('.lunqo-product-card--mobile-deferred:not(.is-mobile-revealed)')];
      if (window.matchMedia('(max-width: 749px)').matches && deferred.length) {
        deferred.forEach((card) => card.classList.add('is-mobile-revealed'));
        this.track('load_more_clicked', { mode: 'reveal', count: deferred.length });
        this.track('products_loaded', { count: deferred.length });
        this.updateProgress();
        this.saveState();
        if (!this.loadButton?.dataset.nextUrl) this.loadButton?.remove();
        return;
      }

      const nextUrl = this.loadButton?.dataset.nextUrl;
      if (!nextUrl || !this.grid) return;
      this.track('load_more_clicked', { mode: 'request' });
      this.setBusy(true);

      try {
        const requestUrl = new URL(nextUrl, window.location.origin);
        requestUrl.searchParams.set('section_id', this.sectionId);
        const response = await fetch(requestUrl, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        if (!response.ok) throw new Error(`Load more failed: ${response.status}`);
        const html = await response.text();
        const documentFragment = new DOMParser().parseFromString(html, 'text/html');
        const nextSection = documentFragment.querySelector(`#LunqoCollection-${CSS.escape(this.sectionId)}`);
        const nextGrid = nextSection?.querySelector('[data-product-grid]');
        if (!nextGrid) throw new Error('Next product grid missing');

        const existingIds = new Set(
          [...this.grid.querySelectorAll('[data-product-card]')].map((card) => card.dataset.productId)
        );
        const newCards = [...nextGrid.children].filter((node) => {
          if (!node.matches('[data-product-card]')) return false;
          return !existingIds.has(node.dataset.productId);
        });
        newCards.forEach((card) => {
          card.classList.add('is-mobile-revealed');
          this.grid.append(card);
        });

        const nextButton = nextSection.querySelector('[data-load-more]');
        if (nextButton?.dataset.nextUrl) {
          this.loadButton.dataset.nextUrl = nextButton.dataset.nextUrl;
        } else {
          this.loadButton.remove();
          this.loadButton = null;
        }

        this.observeProducts();
        this.bindNewCardEvents(newCards);
        this.updateProgress();
        this.saveState();
        this.track('products_loaded', { count: newCards.length });
      } catch (error) {
        this.showError();
      } finally {
        this.setBusy(false);
      }
    }

    bindNewCardEvents(cards) {
      cards.forEach((card) => {
        card.querySelectorAll('[data-product-card-link]').forEach((link) => {
          link.addEventListener('click', () => {
            this.saveState();
            this.track(link.hasAttribute('data-choose-options') ? 'choose_options' : 'product_card_click', {
              product_id: card.dataset.productId,
              product_handle: card.dataset.productHandle
            });
          }, { signal: this.abortController.signal });
        });
        card.querySelector('[data-quick-add]')?.addEventListener('click', (event) => {
          this.track('quick_add', {
            product_id: card.dataset.productId,
            product_handle: card.dataset.productHandle,
            variant_id: event.currentTarget.dataset.variantId
          });
        }, { signal: this.abortController.signal });
      });
    }

    observeProducts() {
      this.observer?.disconnect();
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const card = entry.target;
          const key = `${this.dataset.collectionHandle}:${card.dataset.productId}`;
          if (!LunqoCollection.viewedProducts.has(key)) {
            LunqoCollection.viewedProducts.add(key);
            this.track('product_card_impression', {
              product_id: card.dataset.productId,
              product_handle: card.dataset.productHandle,
              collection_handle: this.dataset.collectionHandle
            });
          }
          this.observer.unobserve(card);
        });
      }, { rootMargin: '120px 0px' });

      this.querySelectorAll('[data-product-card]').forEach((card) => this.observer.observe(card));
    }

    updateProgress() {
      const cards = [...this.querySelectorAll('[data-product-card]')];
      const visibleCards = cards.filter((card) => getComputedStyle(card).display !== 'none');
      const shown = this.querySelector('[data-shown-count]');
      if (shown) shown.textContent = String(visibleCards.length);
    }

    setBusy(isBusy) {
      this.setAttribute('aria-busy', String(isBusy));
      if (this.loadButton) {
        this.loadButton.disabled = isBusy;
        this.loadButton.setAttribute('aria-busy', String(isBusy));
      }
    }

    showError() {
      const message = this.querySelector('[data-load-error]');
      if (message) message.hidden = false;
    }

    closeFilters() {
      if (!this.filterDetails?.open) return;
      this.filterDetails.open = false;
      this.filterDetails.querySelector('summary')?.focus();
    }

    handleDrawerKeys(event) {
      if (!this.filterDetails?.open) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        this.closeFilters();
        return;
      }
      if (event.key !== 'Tab' || !window.matchMedia('(max-width: 989px)').matches) return;
      const focusable = [...this.filterDetails.querySelectorAll('button, a[href], input:not([disabled]), select, [tabindex]:not([tabindex="-1"])')]
        .filter((element) => element.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    serialiseFilters(params) {
      const result = {};
      params.forEach((value, key) => {
        if (!value || key === 'sort_by') return;
        result[key] = result[key] ? [].concat(result[key], value) : value;
      });
      return result;
    }

    saveState() {
      if (!this.grid) return;
      history.replaceState({
        ...history.state,
        lunqoCollection: {
          key: `${location.pathname}${location.search}`,
          grid: this.grid.innerHTML,
          nextUrl: this.loadButton?.dataset.nextUrl || '',
          scrollY: window.scrollY
        }
      }, '');
    }

    restoreSavedState() {
      const saved = history.state?.lunqoCollection;
      const currentKey = `${location.pathname}${location.search}`;
      if (!saved || saved.key !== currentKey || !saved.grid || !this.grid) return;
      if (saved.grid.length <= this.grid.innerHTML.length) return;
      this.grid.innerHTML = saved.grid;
      if (this.loadButton) this.loadButton.dataset.nextUrl = saved.nextUrl;
      requestAnimationFrame(() => window.scrollTo({ top: saved.scrollY, behavior: 'auto' }));
    }

    track(event, payload) {
      const detail = { event, payload };
      document.dispatchEvent(new CustomEvent('lunqo:analytics', { detail }));
      window.dataLayer?.push({ event: `lunqo_${event}`, ...payload });
      window.Shopify?.analytics?.publish?.(`lunqo_${event}`, payload);
    }
  }

  if (!customElements.get('lunqo-collection')) {
    customElements.define('lunqo-collection', LunqoCollection);
  }

  if (!window.lunqoCollectionPopstateBound) {
    window.lunqoCollectionPopstateBound = true;
    window.addEventListener('popstate', () => {
      const collection = document.querySelector('lunqo-collection');
      collection?.renderUrl(window.location.href, false);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lunqo-related-collections"] && !Shopify.designMode) return;
  try {
    
  class LunqoRelatedCollections extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      this.querySelectorAll('[data-related-collection-handle]').forEach((link) => {
        link.addEventListener('click', () => {
          const payload = {
            collection_handle: this.dataset.collectionHandle,
            related_collection_handle: link.dataset.relatedCollectionHandle
          };
          const detail = { event: 'related_collection_click', payload };
          document.dispatchEvent(new CustomEvent('lunqo:analytics', { detail }));
          window.dataLayer?.push({ event: 'lunqo_related_collection_click', ...payload });
          window.Shopify?.analytics?.publish?.('lunqo_related_collection_click', payload);
        }, { signal: this.abortController.signal });
      });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }
  }

  if (!customElements.get('lunqo-related-collections')) {
    customElements.define('lunqo-related-collections', LunqoRelatedCollections);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
